/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import RichTextField from '@molecules/RichTextField';
import { transformApiFormErrors } from '@utils/form';
import { ContentModuleModal } from '@molecules';

import Form from '../Form';

import Item from './Item';
import { FORM_FIELD, FORM_FIELDS } from './constants';

const TextBlock = ({ visible, onSubmit, hide, previewImg, onDelete, initialValues, errors }) => {
  const [form] = Form.useForm();

  React.useEffect(() => {
    if (visible) {
      // Again a dirty hack to show error when modal opens first time because form is working on subscriptions.
      setTimeout(() => {
        form.setFields(transformApiFormErrors(errors?.content, FORM_FIELDS));
      });
    }
  }, [visible, errors, form]);

  const handleClose = () => {
    form.resetFields();
    hide();
  };

  const handleSubmit = (values) => {
    onSubmit(values);
    handleClose();
  };

  // Should be unique name, otherwise WYSIWYG editor won't work correctly if multiple text blocks are added
  const formName = React.useMemo(() => `form_in_modal-${Math.random()}`, []);

  return (
    <ContentModuleModal
      visible={visible}
      title="Text block"
      subtitle="Add a block of formatted text - you can include images and links."
      okText={onDelete ? 'SAVE CHANGES' : 'ADD TEXT BLOCK'}
      onCancel={handleClose}
      onSubmit={form.submit}
      onDelete={onDelete}
      heroImageSrc={previewImg}
      errors={errors}
    >
      <Form form={form} layout="vertical" initialValues={initialValues} onFinish={handleSubmit} name={formName}>
        <RichTextField {...FORM_FIELD.CONTENT} />
      </Form>
    </ContentModuleModal>
  );
};

TextBlock.Item = Item;

export default TextBlock;
